"use strict";Object.defineProperty(exports, "__esModule", {value: true});var OrgSurveyFeature; (function (OrgSurveyFeature) {
  const SMS_MESSAGING = 'SMS_MESSAGING'; OrgSurveyFeature["SMS_MESSAGING"] = SMS_MESSAGING;
  const TEAM_CHAT = 'TEAM_CHAT'; OrgSurveyFeature["TEAM_CHAT"] = TEAM_CHAT;
  const EXTERNAL_CHAT = 'EXTERNAL_CHAT'; OrgSurveyFeature["EXTERNAL_CHAT"] = EXTERNAL_CHAT;
})(OrgSurveyFeature || (exports.OrgSurveyFeature = OrgSurveyFeature = {}));

// A signer may select more than one intent, so `OrgSurvey.productInterest`
// carries a `ProductInterest[]` serialized as a comma-joined set on the wire
// (e.g. `'sms,team_chat'`). The retired `BOTH` scalar is gone; external-org
// messaging is now first-class. The backend still parses legacy `'both'` for
// back-compat (see `pkg/bloom/product_interest.go`).
var ProductInterest; (function (ProductInterest) {
  const SMS = 'sms'; ProductInterest["SMS"] = SMS;
  const TEAM_CHAT = 'team_chat'; ProductInterest["TEAM_CHAT"] = TEAM_CHAT;
  const EXTERNAL_CHAT = 'external_chat'; ProductInterest["EXTERNAL_CHAT"] = EXTERNAL_CHAT;
})(ProductInterest || (exports.ProductInterest = ProductInterest = {}));

var TeamSizeBucket; (function (TeamSizeBucket) {
  const SOLO = '1'; TeamSizeBucket["SOLO"] = SOLO;
  const SMALL = '2_5'; TeamSizeBucket["SMALL"] = SMALL;
  const MEDIUM = '6_15'; TeamSizeBucket["MEDIUM"] = MEDIUM;
  const LARGE = '16_plus'; TeamSizeBucket["LARGE"] = LARGE;
})(TeamSizeBucket || (exports.TeamSizeBucket = TeamSizeBucket = {}));
